/**
 * author       : zwl
 * createTime   : 2018/6/28 下午5:08
 * description  :
 */
import api from 'util/axios'

/**
 * 通过车牌号模糊查询当前应用下的车辆详情
 * @param number
 * @param pageSize
 * @param current
 */
export function getCarForNumber (number, appId, pageSize, current) {
  return api({
    method: 'get',
    url: '/car/' + number,
    params: {pageSize: pageSize, current: current, appId: appId}
  })
}

/**
 * 通过车牌号查询车辆，如果没有就创建
 * @param number
 */
export function selectCar (number, appId) {
  return api({
    method: 'get',
    url: '/car/find/' + number,
    params: {appId: appId}
  })
}

export function carListByApp (params) {
  return api({
    method: 'post',
    url: '/car/app/carListByApp/' + params.appId,
    data: params
  })
}
/**
 * 根据车牌号码查询车辆
 * @param {应用ID} appid
 * @param {司机参数} driverParam
 */
export function carGroupByPhone (appId, driverParam) {
  return api({
    method: 'post',
    url: '/car/app/carGroupByPhone/' + appId,
    data: driverParam
  })
}

/**
 * 车辆分组添加
 * @param {应用ID} appid
 * @param {车辆ID} carId
 */
export function addCarGroup (appId, groupId, carIds) {
  return api({
    method: 'post',
    url: '/car/app/addCarGroup/' + appId + '/' + groupId,
    data: carIds
  })
}

export function deleteCarGroup (appId, groupId, carId) {
  return api({
    method: 'post',
    url: '/car/app/deleteCarGroup/' + appId,
    params: {carId, groupId}
  })
}
